import React, { ComponentProps } from 'react';
import { DefaultView, EditView, Views } from '../../types/BlockWithViews';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { RoleSettingsEditView } from './views/RoleSettingsEditView';
import { useAppContext } from '../../contexts/AppContext/AppContext';
import { RoleSettingsDefaultView } from './views/RoleSettingsDefaultView';

type RoleValidForPageTypeSettingsProps = Views<DefaultView<RoleSettingsDefaultView> & EditView<RoleSettingsEditView>>;
function RoleValidForPageTypeSettings(props: RoleValidForPageTypeSettingsProps) {
  const { active } = useAppContext().editModeInfo;
  return active ? <RoleSettingsEditView {...props.views.edit} /> : <RoleSettingsDefaultView {...props.views.default} />;
}

export const RoleValidForPageTypeSettingsBlock = asFetchableBlock(
  RoleValidForPageTypeSettings,
  BlockType.rolevalidforpagetypesettings
);
export type RoleValidForPageTypeSettingsBlock = ComponentProps<typeof RoleValidForPageTypeSettingsBlock>;
